import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=a520b430&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a520b430')) {
      api.createRecord('a520b430', component.options)
    } else {
      api.reload('a520b430', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=a520b430&", function () {
      api.rerender('a520b430', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-26dA8BmzAFt9P/JS/comp/openstreetmap.vue"
export default component.exports